/** @format */

import React, { useEffect, useState } from "react";

import { LoginPage as TablerLoginPage, Alert } from "tabler-react";
import { Formik } from "formik";
import axios from "axios";

import { ROUTES } from "../../../route";
import { useHistory } from "react-router-dom";
import { SERVER_URL } from "../../../utils/server.constant";
const  logoUrl=  "./logomlm.png";


const Login = () => {
  const history = useHistory();
  const [error, setError] = useState("");
  const _bootscreen = async () => {
    const token = await localStorage.getItem("token");

    if (token) {
      history.push(ROUTES.DASHBOARD);
    }
  };
  useEffect(() => {
    _bootscreen();
  }, []);
  const _onlogin = async (values) => {
    await axios
      .post(`${SERVER_URL}/admin/login`, {
        email: values.email,
        password: values.password,
      })
      .then(async (res) => {
        if (res?.data?.flag === true) {
          await localStorage.setItem("token", res.data.data);
          await history.push(ROUTES.DASHBOARD);
        } else {
          setError("Invalid Email Or Password");
        }
      })
      .catch((e) => {
        setError("Invalid Email Or Password");
      });
  };
  return (
    <div>
      <Formik
        initialValues={{
          email: "",
          password: "",
        }}
        validate={(values) => {
          // same as above, but feel free to move this into a class method now.
          let errors = {};
          if (!values.email) {
            errors.email = "Required";
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
          ) {
            errors.email = "Invalid email address";
          }
          return errors;
        }}
        onSubmit={(
          values,
          { setSubmitting, setErrors /* setValues and other goodies */ }
        ) => {
          _onlogin(values);
          // console.log(values, "valuesvalues");
          // history.push(ROUTES.DASHBOARD);
        }}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <>
            {error && <Alert type="danger">{error}</Alert>}
            <TablerLoginPage
            logoUrl={logoUrl}
              onSubmit={handleSubmit}
              onChange={handleChange}
              onBlur={handleBlur}
              values={values}
              errors={errors}
              touched={touched}
            />
          </>
        )}
      />
    </div>
  );
};
export default Login;
